import { NavLink } from 'react-router-dom';
import { UserButton } from '@clerk/clerk-react';
import { useLingui } from '@lingui/react';
import {
  LayoutDashboard,
  Briefcase,
  ArrowDownToLine,
  PieChart,
  UserCog,
  Settings,
  Building2,
} from 'lucide-react';
import { useIsAdmin } from '../../hooks/useRole';
import { ThemeToggle } from './ThemeToggle';

export function Sidebar() {
  const { _ } = useLingui();
  const isAdmin = useIsAdmin();

  const userNavItems = [
    { path: '/dashboard', label: _({ id: 'nav.user.dashboard' }), Icon: LayoutDashboard },
    { path: '/exchanges', label: _({ id: 'nav.user.exchanges' }), Icon: Building2 },
    { path: '/portfolio', label: _({ id: 'nav.user.portfolio' }), Icon: PieChart },
    { path: '/tax', label: _({ id: 'nav.user.tax' }), Icon: ArrowDownToLine },
    { path: '/profile', label: _({ id: 'nav.user.profile' }), Icon: UserCog },
  ];
  const adminNavItems = [
    { path: '/admin', label: _({ id: 'nav.admin.dashboard' }), Icon: LayoutDashboard },
    { path: '/admin/exchanges', label: _({ id: 'nav.admin.exchanges' }), Icon: Settings },
  ];
  const items = isAdmin ? adminNavItems : userNavItems;

  return (
    <aside className="menu bg-base-200 min-h-screen w-64 p-4 flex flex-col gap-0">
      {/* Branding */}
      <div className="mb-6 px-3 flex items-center gap-2">
        <Briefcase size={24} strokeWidth={2.25} className="text-primary" aria-hidden="true" />
        <span className="font-bold text-lg leading-tight">{_({ id: 'nav.branding.title' })}</span>
      </div>

      {/* Nav items */}
      <ul className="flex-1 space-y-0.5">
        {items.map((item) => (
          <li key={item.path}>
            <NavLink
              to={item.path}
              end={item.path !== '/admin/exchanges'}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-base-content text-base-100 border border-base-content shadow-sm'
                    : 'text-base-content hover:bg-base-300'
                }`
              }
            >
              <item.Icon size={16} strokeWidth={2.25} className="shrink-0" aria-hidden="true" />
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>

      {/* Bottom actions */}
      <div className="mt-auto flex items-center justify-between pt-4 border-t border-base-300">
        <UserButton afterSignOutUrl="/" />
        <ThemeToggle />
      </div>
    </aside>
  );
}
